import { Grid, Theme, Typography } from '@mui/material'
import makeStyles from '@mui/styles/makeStyles'
import classNames from 'classnames'
import { FormattedMessage } from 'react-intl'
import { useSelector } from 'react-redux'

const useStyles = makeStyles((theme: Theme) => ({
  subtitle: {
    fontStyle: 'normal',
    color: theme.customPalette.siteNavigationText,
    [theme.breakpoints.up('md')]: {
      marginLeft: -20,
    },
  },
  contentContainer: {
    marginLeft: 20,
    width: 250,
    [theme.breakpoints.up('md')]: {
      margin: 'auto',
    },
    [theme.breakpoints.down('md')]: {
      maxWidth: '100%',
      width: '100%',
    },
  },
  contestContainer: {
    [theme.breakpoints.down('sm')]: {
      width: '100%',
    },
  },
  gameTitle: {
    width: 250,
    [theme.breakpoints.up('md')]: {
      margin: 'auto',
    },
  },
}))

interface Props {
  round: number
}

const ContestInfo = ({ round }: Props) => {
  const classes = useStyles()
  const tournamentSite = useSelector((state: StoreState) => state.tournamentReducer.tournamentSite)
  const roundData = tournamentSite.tournament.rounds[round]
  if (!roundData.contestsEnabled) {
    return null
  }

  return (
    <Grid item xs={12} sm={6}>
      <div className={classes.gameTitle}>
        <Typography variant="h4" className={classes.subtitle}>
          <FormattedMessage id={'strings.contests'} />
        </Typography>
      </div>
      <table className={classNames([classes.contentContainer, classes.contestContainer])}>
        <tbody>
          {roundData.contestOptions.closestToPin.length > 0 && (
            <tr>
              <td style={{ paddingRight: 10, width: 170 }}>
                <Typography variant="body1">
                  <FormattedMessage id="strings.closestToPinHoles" />:
                </Typography>
              </td>
              <td>
                <Typography variant="body1">
                  <strong>
                    {roundData.contestOptions.closestToPin
                      .slice()
                      .sort(function (a, b) {
                        return String(a).localeCompare(String(b), undefined, {
                          numeric: true,
                          sensitivity: 'base',
                        })
                      })
                      .join(', ')}
                  </strong>
                </Typography>
              </td>
            </tr>
          )}
          {roundData.contestOptions.longestDrive.length > 0 && (
            <tr>
              <td style={{ paddingRight: 10 }}>
                <Typography variant="body1">
                  <FormattedMessage id="strings.longestDriveHoles" />:
                </Typography>
              </td>
              <td>
                <Typography variant="body1">
                  <strong>
                    {roundData.contestOptions.longestDrive
                      .sort(function (a, b) {
                        return String(a).localeCompare(String(b), undefined, {
                          numeric: true,
                          sensitivity: 'base',
                        })
                      })
                      .join(', ')}
                  </strong>
                </Typography>
              </td>
            </tr>
          )}
          {roundData.contestOptions.straightestDrive.length > 0 && (
            <tr>
              <td style={{ paddingRight: 10 }}>
                <Typography variant="body1">
                  <FormattedMessage id="strings.straightestDriveHoles" />:
                </Typography>
              </td>
              <td>
                <Typography variant="body1">
                  <strong>
                    {roundData.contestOptions.straightestDrive
                      .sort(function (a, b) {
                        return String(a).localeCompare(String(b), undefined, {
                          numeric: true,
                          sensitivity: 'base',
                        })
                      })
                      .join(', ')}
                  </strong>
                </Typography>
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </Grid>
  )
}

export default ContestInfo
